var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.05 4.00002H19.45V20.8H5.05V4.00002H7.45V2.80002C7.45 2.1635 7.70286 1.55306 8.15294 1.10297C8.60303 0.652881 9.21348 0.400024 9.85 0.400024H14.65C15.2865 0.400024 15.897 0.652881 16.3471 1.10297C16.7971 1.55306 17.05 2.1635 17.05 2.80002V4.00002ZM20.65 4.00002H21.85C22.4865 4.00002 23.097 4.25288 23.5471 4.70297C23.9971 5.15306 24.25 5.7635 24.25 6.40002V18.4C24.25 19.0365 23.9971 19.647 23.5471 20.0971C23.097 20.5472 22.4865 20.8 21.85 20.8H20.65V4.00002ZM3.85 4.00002V20.8H2.65C2.01348 20.8 1.40303 20.5472 0.952944 20.0971C0.502856 19.647 0.25 19.0365 0.25 18.4V6.40002C0.25 5.08002 1.33 4.00002 2.65 4.00002H3.85ZM9.85 2.80002V4.00002H14.65V2.80002H9.85Z",
    fill: "#CBD0D1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.31a5b739.svg";
export { ForwardRef as ReactComponent };